import React from 'react';

import aimanErbad from './media/aimanErbad.jpg';
import aimanErbad2x from './media/aimanErbad@2x.jpg';
import jesseBerwald from './media/jesseBerwald.jpg';
import jesseBerwald2x from './media/jesseBerwald@2x.jpg';
import johnDexheimer from './media/johnDexheimer.jpg';
import johnDexheimer2x from './media/johnDexheimer@2x.jpg';
import nicholasChancellor from './media/nicholasChancellor.jpg';
import nicholasChancellor2x from './media/nicholasChancellor@2x.jpg';
import raoufDridi from './media/raoufDridi.jpg';
import raoufDridi2x from './media/raoufDridi@2x.jpg';
import rifatHamoudi from './media/rifatHamoudi.jpg';
import rifatHamoudi2x from './media/rifatHamoudi@2x.jpg';
import salehIbrahim from './media/salehIbrahim.jpg';
import salehIbrahim2x from './media/salehIbrahim@2x.jpg';


const aboutUs = {
    intro: {
        title: 'About Us',
    },
    subIntro: {
        children: (
            <>
                Qamia is the first quantum computing company in the MENA region. We deliver sovereign AI, optimization, and post-quantum cryptography solutions for enterprise and government.
            </>
        ),
    },
    // defines a component
    peopleSection: { 
        children: [
            {
                image: [
                    raoufDridi,
                    raoufDridi2x,
                ],
                title: 'Raouf Dridi',
                subTitle: 'PhD - CoFounder & CEO',
                social: [
                    {
                        icon: 'icon-linkedin-filled',
                        url: 'https://www.linkedin.com/in/raouf-dridi/',
                    },
                ],
                children: 'With a PhD in Mathematics, Raouf has spent decades at the forefront of quantum technology. He served as Advanced Technology Team Leader at Quantum Computing Inc. and Quantum ML & Optimization Lead at 1Qbit. He holds multiple patents in quantum computing and co-founded the quantum computing group at Carnegie Mellon University. As CEO, Raouf leads Qamia\'s vision and strategy in quantum optimization and post-quantum cryptography.',
            },
            {
                image: [
                    jesseBerwald,
                    jesseBerwald2x,
                ],
                title: 'Jesse Berwald',
                subTitle: 'PhD - CoFounder & CTO',
                social: [
                    {
                        icon: 'icon-linkedin-filled',
                        url: 'https://www.linkedin.com/in/jesse-berwald/',
                    },
                ],
                children: 'Jesse has spent over a decade as a technology leader in diverse roles. A deeply technical generalist, in his professional life he has held positions as a data scientist in retail, a senior consultant at D-Wave Systems, and a Principal Quantum Software Architect at Quantum Computing, Inc. He holds multiple patents across a number of technology spaces. He focuses on building robust technology and strong relationships with partners and within his teams. Jesse brings his passion for creating disruptive technology to guide the technological path in his role as CTO at Qamia.',
            },
            {
                image: [
                    aimanErbad,
                    aimanErbad2x,
                ],
                title: 'Aiman Erbad',
                subTitle: 'PhD - CoFounder',
                social: [
                    {
                        icon: 'icon-linkedin-filled',
                        url: 'https://www.linkedin.com/in/aerbad/',
                    },
                ],
                children: 'Aiman brings deep regional expertise and research leadership to Qamia\'s strategic direction. He serves as VP of Research and Graduate Studies and Professor of Computer Engineering at Qatar University, with over two decades of experience in network security, IoT, and distributed systems. He holds a PhD in Computer Science from UBC (Canada), multiple US patents, and has published over 220 papers. Aiman serves on the boards of AIR Institute (Spain) and Qatar Mobility Innovations Center.',
            },
        ],
    },
    peopleSection1: {
        title: 'Advisors',
        children: [
            {
                image: [
                    johnDexheimer,
                    johnDexheimer2x,
                ],
                title: 'John Dexheimer',
                subTitle: 'Lightwave Advisors, LLC',
                social: [
                    {
                        icon: 'icon-linkedin-filled',
                        url: 'https://www.linkedin.com/in/john-dexheimer-53101a6/',
                    },
                ],
                children: "John has advised on over 100 completed company financings and mergers in software, communications, electronics and materials. He has extensive history with venture capital investing as a co-investor and advisor on portfolio firms of many of the well know, active investors in technology sectors. He has helped found startups and has a record of initiating and structuring successful private investments for affiliated equity funds. He earned an MBA from Harvard University and a B.S. from the University of Minnesota, College of Science and Engineering where he is on the Dean's Advisory. He has been an Entrepreneur-in-Residence at Yale, on the Advisory board of the NSF IMA and the NSF ERC.",
            },
            {
                image: [
                    rifatHamoudi,
                    rifatHamoudi2x,
                ],
                title: 'Rifat Hamoudi',
                subTitle: 'University of Sharjah',
                social: [
                    {   icon: 'icon-user',
                        url: 'https://www.sharjah.ac.ae/Academics/Faculty-And-Staff/Rifat-Hamoudi',
                    },
                    {
                        icon: 'icon-user',
                        url: 'https://profiles.ucl.ac.uk/11462-rifat-hamoudi',
                    },
                ],
                children: 'Dr. Hamoudi is currently the director of the Centre of Excellence for Precision Medicine at the University of Sharjah. He is an interdisciplinary researcher with a deep background and experience that spans the fields of Medicine, Engineering and Computer Science. He has three different MSc degrees from the University of London in Biochemistry & Molecular Biology, Electronics and Information Engineering and Computer Science respectively. He has a PhD from University of Cambridge in Pathology and Immunology.',
            },
            {
                image: [
                    nicholasChancellor,
                    nicholasChancellor2x,
                ],
                title: 'Nicholas Chancellor',
                subTitle: 'PhD, Newcastle University',
                social: [
                    {
                        icon: 'icon-linkedin-filled',
                        url: 'https://www.linkedin.com/in/nick-chancellor-55243718/',
                    },
                ],
                children: 'Dr. Nicholas Chancellor is a world renowned expert in quantum computing and assistant professor at Newcastle University within the School of Computing. His research interests extend from theoretical physics to applications of quantum computing for industrial problems. His work has directly influenced the development of novel hardware and software at various companies. He has been on the program committee of a number of conferences including being the chair of the program committee for AQC \'24, and has served on a number of editorial boards of well respected journals. Additionally, Dr. Chancellor has consulted for both industry and national labs including his expertise being tapped by the UK Defense Science and Technology lab through the Pathfinder project.',
            },
            {
                image: [
                    salehIbrahim,
                    salehIbrahim2x,
                ],
                title: 'Saleh Ibrahim',
                subTitle: 'Khalifa University',
                social: [
                    {
                        icon: 'icon-user',
                        url: 'https://www.ku.ac.ae/college-people/saleh-mohamed-saleh-ibrahim',
                    },
                ],
                children: 'Professor Saleh Ibrahim is an Immunology expert and associate dean for research at Khalifa University\'s College of Medicine and Health Sciences. His research examines genetic susceptibility to complex diseases and gene-microbiota interactions in inflammatory and metabolic diseases. Dr. Ibrahim began his research career at Helsinki University, earning his doctorate in immunology. After postdoctoral training at Princeton University researching lupus genetics, he established a research group at the University of Rostock in 1997 focusing on autoimmune diseases\' genetic basis. In 2008, he became a professor of Genetics at Luebeck University before joining Khalifa University in 2022.'
            },
        ],
    },
};

export default aboutUs;
